module.exports = __webpack_public_path__ + "img/module11.3560a3ea.png";